import { Navigate, type RouteObject } from 'react-router-dom';
import AssetTypePage from './pages/AssetTypePage';
import AssetsPage from '../pages/AssetsPage';
import NewAssetTypePage from './pages/NewAssetTypePage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <AssetsPage tab="types" />,
  },
  {
    path: 'new',
    element: <NewAssetTypePage />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <AssetTypePage />,
      },
    ],
  },
];

export default routes;
